import { Tag } from '@omnipresentgroup/design-system';
import { LeaveTypeEnum } from '@omnipresentgroup/types';

const leaveTypeMap = {
  [LeaveTypeEnum.SICK]: 'Sick leave',
};

export const LeaveType = ({ status }: { status: LeaveTypeEnum }) => {
  return (
    <Tag id={'leave-type-tag'} intent="info">
      {leaveTypeMap[status]}
    </Tag>
  );
};
